var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStack1Dark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4873_30493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1305 10.4348H0.869531C0.389531 10.4348 0 10.8243 0 11.3043V39.1305C0 39.6105 0.389531 40 0.869531 40H39.1305C39.6105 40 40 39.6105 40 39.1305V11.3044C40 10.8244 39.6105 10.4348 39.1305 10.4348ZM38.2609 38.2609H1.73914V12.174H38.2609V38.2609Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6522 5.21753H4.3478C3.8678 5.21753 3.47827 5.60706 3.47827 6.08706V7.8262C3.47827 8.3062 3.8678 8.69573 4.3478 8.69573C4.8278 8.69573 5.21733 8.3062 5.21733 7.8262V6.95667H34.7826V7.8262C34.7826 8.3062 35.1721 8.69573 35.6521 8.69573C36.1321 8.69573 36.5216 8.3062 36.5216 7.8262V6.08706C36.5217 5.60706 36.1322 5.21753 35.6522 5.21753Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1739 0H7.82607C7.34607 0 6.95654 0.389531 6.95654 0.869531V2.60867C6.95654 3.08867 7.34607 3.4782 7.82607 3.4782C8.30607 3.4782 8.69561 3.08867 8.69561 2.60867V1.73914H31.3043V2.60867C31.3043 3.08867 31.6938 3.4782 32.1738 3.4782C32.6538 3.4782 33.0433 3.08867 33.0433 2.60867V0.869531C33.0435 0.389531 32.6539 0 32.1739 0Z",
    fill: "black",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4873_30493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStack1Dark);
export default __webpack_public_path__ + "static/media/stack-1-dark.3257b231f3296963a13428210d8e1835.svg";
export { ForwardRef as ReactComponent };